module.exports = __webpack_public_path__ + "media/images/flags/16/Angola-a3c7f1584f424230b47b6fdf0f2e1c38.png";